import { Badge, Card, Col, Row, Space } from 'antd'
import { useTranslation } from 'react-i18next'
import { Suspense, useContext, useEffect, useMemo } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import ErrorBoundary from '../ErrorBoundary'
import PageLoading from '../components/PageLoading'
import { gutter } from '../lib/layout'
import { SideMenu } from '../components/SideMenu'
import { BellOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons'
import { NotificationsPage } from './my-account/notifications'
import { PersonalDataPage } from './my-account/personalData'
import { BaseLayoutContext } from '../components/BaseLayoutContext'
import { useUnreadNotificationCount } from '../lib/useUnreadNotificationCount'
import { SettingsPage } from './my-account/settings'

export function MyAccount() {
  const { t } = useTranslation()
  const [, setTopMenu] = useContext(BaseLayoutContext)

  const unreadNotificationCount = useUnreadNotificationCount()

  const menu = useMemo(
    () => [
      {
        key: `/my-account/personal-data`,
        icon: <UserOutlined />,
        label: <Space>{t('frontend:myAccount.nav.personalData')}</Space>,
      },
      {
        key: `/my-account/settings`,
        icon: <SettingOutlined />,
        label: <Space>{t('frontend:myAccount.nav.settings')}</Space>,
      },
      {
        key: `/my-account/notifications`,
        icon: <BellOutlined />,
        label: (
          <Space>
            {t('frontend:myAccount.nav.notifications')}{' '}
            <Badge count={unreadNotificationCount} />
          </Space>
        ),
      },
    ],
    [unreadNotificationCount, t]
  )

  useEffect(() => {
    setTopMenu({
      selectedProfile: null,
      menu,
      homeLink: `/my-account/personal-data`,
    })
  }, [menu, setTopMenu])

  const location = useLocation()

  return (
    <Row gutter={gutter}>
      <Col xs={0} lg={6} xl={5}>
        <Card bordered={false} styles={{ body: { padding: '8px' } }}>
          <SideMenu items={menu} />
        </Card>
      </Col>
      <Col xs={24} lg={18} xl={19}>
        <Suspense fallback={<PageLoading />}>
          <ErrorBoundary location={location}>
            <Routes>
              <Route index element={<></>} />
              <Route path="notifications" element={<NotificationsPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="personal-data" element={<PersonalDataPage />} />
            </Routes>
          </ErrorBoundary>
        </Suspense>
      </Col>
    </Row>
  )
}
